import { Flex, ScaleFade, Box } from '@chakra-ui/react';

import { HeaderUp } from '../../../../components/_components_0.2/Header_0.2';
import { Sidebar } from '../../../../components/_components_0.2/Sidebar_0.2';
import { DriverKilometerTable } from '../../../../components/_components_0.2/Miles/DriverKilometerTable';

export default function DriverKilometers() {
  return (
    <Flex direction="column" h="100vh">
      <HeaderUp path="miles" />

      <Flex w="100%" my="6" maxWidth={1480} mx="auto" pb={4} px="6">
        <Sidebar path="miles" />
        <Box w="100%">
          <ScaleFade initialScale={0.9} in>
            <DriverKilometerTable />
          </ScaleFade>
        </Box>
      </Flex>
    </Flex>
  );
}
